import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { VendorService } from '../../vendor-portal/vendor.service';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormUtils } from '../../utilities/FormUtils/FormUtils';
import { PhoneUtils } from '../../utilities/PhoneUtils/PhoneUtils';
import { EmailValidationService } from '../../services/email-validation.service';

@Component({
  selector: 'app-create-customer',
  templateUrl: './create-customer.component.html',
  styleUrls: ['./create-customer.component.css']
})
export class CreateCustomerComponent implements OnInit {

  form: FormGroup;
  errorMessage: string = '';
  isSubmitting: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<CreateCustomerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private vendor: VendorService,
    private emailValidationService: EmailValidationService
  ) {
    this.form = new FormGroup({
      name: new FormControl('', [Validators.required]),
      phones: new FormArray([new FormControl('', [Validators.required])]),
      email: new FormControl('', [this.emailValidationService.validateEmail.bind(this.emailValidationService)])
    });
  }

  ngOnInit() {
  }

  get phones(): FormArray {
    return this.form.get('phones') as FormArray;
  }

  addPhone() {
    // Extra rows are optional until filled; only the first is required.
    this.phones.push(new FormControl(''));
  }

  removePhone(index: number) {
    if (this.phones.length <= 1) {
      return;
    }
    this.phones.removeAt(index);
    this.syncPhoneValidators();
  }

  makePrimary(index: number) {
    if (index <= 0 || index >= this.phones.length) {
      return;
    }
    const control = this.phones.at(index);
    this.phones.removeAt(index);
    this.phones.insert(0, control);
    this.syncPhoneValidators();
  }

  private syncPhoneValidators() {
    this.phones.controls.forEach((ctrl, i) => {
      if (i === 0) {
        ctrl.setValidators([Validators.required]);
      } else {
        ctrl.clearValidators();
      }
      ctrl.updateValueAndValidity();
    });
  }

  close() {
    this.dialogRef.close();
  }

  getClass(name) {
    if (this.isFieldInvalid(name)) {
      return 'form-control round-input error-border';
    } else {
      return 'form-control round-input';
    }
  }

  isFieldInvalid(name: string, index?: number): boolean {
    var field = name === 'phones' && index != null
      ? this.phones.at(index)
      : this.form.get(name);
    if (!field) {
      return false;
    }
    if (name == 'email') {
      if (field.getError('invalidEmail') && field.touched) {
        if (field.value == '' || !field.value) {
          return false;
        } else {
          return true;
        }
      }
    }
    if (field.invalid && field.touched) {
      return true;
    }
    return false;
  }

  getFieldErrorMessage(name: string, index?: number): string {
    var field = name === 'phones' && index != null
      ? this.phones.at(index)
      : this.form.get(name);
    if (!field || !(field.invalid && field.touched)) {
      return '';
    }
    if (field.errors && field.errors['required']) {
      if (name === 'phones') {
        return 'Phone number is required.';
      }
      return `${name.charAt(0).toUpperCase() + name.slice(1)} is required.`;
    }
    if (field.errors && field.errors['invalidEmail']) {
      return this.emailValidationService.getEmailErrorMessage();
    }
    if (field.errors && field.errors['invalidPhone']) {
      return 'Please enter a valid 10-digit phone number (digits only, e.g. 8764335126).';
    }
    return '';
  }

  private collectPhones(): string[] {
    const seen = {};
    const phones = [];
    this.phones.controls.forEach((ctrl) => {
      const normalized = PhoneUtils.toTenDigitPhone(ctrl.value);
      if (normalized && !seen[normalized]) {
        seen[normalized] = true;
        phones.push(normalized);
      }
    });
    return phones;
  }

  save() {
    FormUtils.markFormGroupTouched(this.form);
    if (this.form.valid) {
      const phones = this.collectPhones();
      if (!phones.length) {
        this.errorMessage = 'At least one valid phone number is required.';
        return;
      }

      this.isSubmitting = true;
      this.errorMessage = '';

      const form = this.form.getRawValue();
      this.vendor.createCustomer({
        name: form.name,
        email: form.email,
        phone: phones[0],
        phones: phones
      }).then((res) => {
        this.isSubmitting = false;
        if (res && res.status) {
          this.dialogRef.close(true);
        } else {
          this.errorMessage = (res && res.message) ? res.message : 'Failed to create customer. Please try again.';
        }
      }).catch(e => {
        this.isSubmitting = false;
        console.error(e);
        if (e._body) {
          try {
            var body = JSON.parse(e._body);
            this.errorMessage = body.message;
          } catch (parseErr) {
            this.errorMessage = 'Failed to create customer. Please try again.';
          }
        } else {
          this.errorMessage = 'Failed to create customer. Please try again.';
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin-dashboard/create-customer/create-customer.component.ts